import router from 'next/router';
import fetchNext from '@features/api/fetchNext';
import isValidCommerceCustomerId from '@features/customerData/utils/isValidCommerceCustomerId';
import getPublicEnv from '@utils/getPublicEnv';
class NextCreativeApi {
  public endpoints = {
    getCreativeProjects: (customerId: string) => `customer/${customerId}/creative/getCreativeProject`,
    saveCreativeProject: (customerId: string, configurationId: string) => `customer/${customerId}/creative/${configurationId}/saveCreativeProject`,
    editCreativeProject: (customerId: string, configurationId: string) => `customer/${customerId}/creative/${configurationId}/editCreativeProject`,
    deleteCreativeProject: (customerId: string, configurationId: string) => `customer/${customerId}/creative/${configurationId}/deleteCreativeProject`
  };
  private static getLocale() {
    const isServerSide = typeof window === 'undefined';
    if (isServerSide) return process.env.DEFAULT_LOCALE;
    const {
      locale
    } = router;
    return locale || getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE');
  }
  public async getCreativeProjects(customerId: string) {
    const {
      json
    } = await fetchNext(this.endpoints.getCreativeProjects(customerId), {
      method: 'GET'
    }, NextCreativeApi.getLocale());
    return json;
  }
  public async saveCreativeProject(customerId: string, configurationId: string, name: string, description: string, imageUrl: string) {
    if (!isValidCommerceCustomerId(customerId) || !configurationId?.trim()) {
      return {
        error: true
      };
    }
    const {
      json
    } = await fetchNext(this.endpoints.saveCreativeProject(customerId.trim(), configurationId.trim()), {
      method: 'POST',
      body: JSON.stringify({
        name,
        description,
        imageUrl
      })
    }, NextCreativeApi.getLocale());
    return json;
  }
  public async editCreativeProject(customerId: string, configurationId: string) {
    const {
      json
    } = await fetchNext(this.endpoints.editCreativeProject(customerId, configurationId), {
      method: 'PUT'
    }, NextCreativeApi.getLocale());
    return json;
  }
  public async deleteCreativeProject(customerId: string, configurationId: string) {
    const {
      json
    } = await fetchNext(this.endpoints.deleteCreativeProject(customerId, configurationId), {
      method: 'DELETE'
    }, NextCreativeApi.getLocale());
    return json;
  }
}
export default new NextCreativeApi();